import { render, staticRenderFns } from "./ImportDocuments_edit.vue?vue&type=template&id=5bc59cf3&scoped=true"
import script from "./ImportDocuments_edit.vue?vue&type=script&lang=js"
export * from "./ImportDocuments_edit.vue?vue&type=script&lang=js"
import style0 from "./ImportDocuments_edit.vue?vue&type=style&index=0&id=5bc59cf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc59cf3",
  null
  
)

export default component.exports